import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M375-319q-113 0-190-78-78-78-78-188t78-188q78-78 188-78 111 0 188 78t77 188q0 44-13 83t-39 74l238 236q12 12 12 29t-12 29q-12 12-29 12t-28-12L529-371q-29 24-69 38t-85 14Zm-1-80q77 0 131-54 54-55 54-132t-54-132q-54-54-131-54-79 0-133 54-55 55-55 132t55 132q54 54 133 54Z"/>',
  f: '<path d="M375-319q-113 0-190-78-78-78-78-188t78-188q78-78 188-78 111 0 188 78t77 188q0 44-13 83t-39 74l238 236q12 12 12 29t-12 29q-12 12-29 12t-28-12L529-371q-29 24-69 38t-85 14Zm-1-80q77 0 131-54 54-55 54-132t-54-132q-54-54-131-54-79 0-133 54-55 55-55 132t55 132q54 54 133 54Z"/>',
};

export default data;
